import {Component, OnInit}          from '@angular/core';
import {SessionService}             from '../services/session.service';
import {Router}                     from '@angular/router';
import {PopoverController}          from '@ionic/angular';
import {HomePopOverComponent}       from '../components/home-pop-over/home-pop-over.component';
import {APIService, PermissionType} from 'src/app/API.service';
import {BehaviorSubject}            from 'rxjs';
import {DataStore}                  from 'aws-amplify';
import {Notification}               from "../../models";


@Component({
    selector: 'app-home',
    templateUrl: 'home.page.html',
    styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit {

    cssClass: string;
    pageTitle: string;
    primaryColor: any;
    secondryColor: any;
    fullWhiteLogo: any;
    usersCount: number;
    teamsCount: number;
    clientsCount: number;
    contractsCount: number;
    permessionsType = PermissionType;
    loading = new BehaviorSubject(true);
    number = 0;

    constructor(
            public sessionService: SessionService,
            public popoverController: PopoverController,
            private router: Router,
            private apiService: APIService,
    ) {

    }

    ngOnInit() {
        DataStore.start();
        this.sessionService.user$.subscribe(x => {
            if (!x) {
                this.loading.next(true);
            } else {
                this.loading.next(false);
                switch (this.sessionService.user?.permessions) {
                    case PermissionType.CLIENT:
                        this.pageTitle = 'CLIENTE';
                        DataStore.observeQuery(Notification, s => s.userId('eq', this.sessionService.user?.id).isSeen('ne',true)).subscribe(x => {
                            this.number = x.items.length;
                        })
                        break;
                    case PermissionType.COMMERCIAL:
                        this.pageTitle = 'COMMERCIALE';
                        DataStore.observeQuery(Notification, s => s.userId('eq', this.sessionService.user?.id).isSeen('ne',true)).subscribe(x => {
                            this.number = x.items.length;
                        })
                        break;
                    case PermissionType.ADMINISTRATOR:
                        this.pageTitle = 'AMMINISTRATORE';
                        DataStore.observeQuery(Notification, s => s.isAdmin('eq', true).isSeen('ne',true)).subscribe(x => {
                            this.number = x.items.length;
                        })
                        break;
                    default:
                        break;
                }
            }
        });



    }

    async ionViewDidEnter() {
        this.loading.subscribe(x => {
            if (x == false) {
                new Promise((resolve) => setTimeout(resolve, 1000)).then(() => {
                    this.applyClassBySelection('zoomIn');
                    // const currentUser =  this.sessionService.getCurrentUser();

                    // this.usersCount = (await DataStore.query(User)).length;
                    // this.teamsCount = (await DataStore.query(Team)).length;
                    // this.clientsCount = (await DataStore.query(User, u => u.role("eq", Roles.CLIENT.displayName))).length;
                    // // this.contractsCount =  (await DataStore.query(Contract)).filter(c => c.addedBy?.id == currentUser?.id).length;
                    // this.contractsCount =  (await DataStore.query(Contract)).length;

                    // make sure the newly styled content scrolls when needed
                    document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');

                });

            }
        });
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    async showModal(ev: any) {
        const popover = await this.popoverController.create({
            component: HomePopOverComponent,
            event: ev,
            translucent: true,
            componentProps: {
                'type': 'homeOptions',
            },
        });
        return await popover.present();
    }

    applyClassBySelection(effect: string): void {
        this.cssClass = 'animated ' + effect;
    }


    showNotifications() {
        //  this.showModal();
    }
}
